var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 10.4004L5.6 7.20039L6.45 6.35039L8.2 8.10039V2.40039H9.4V8.10039L11.15 6.35039L12 7.20039L8.8 10.4004ZM5.19533 12.8004C4.86511 12.8004 4.58333 12.6829 4.35 12.4479C4.11667 12.2129 4 11.9304 4 11.6004V10.4004H5.2V11.6004H12.4V10.4004H13.6V11.6004C13.6 11.9304 13.4824 12.2129 13.2473 12.4479C13.0122 12.6829 12.7296 12.8004 12.3993 12.8004H5.19533Z",
    fill: "#93929C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4a54ec9760c28fc93b3f8e87b97cacde.svg";
export { ForwardRef as ReactComponent };